import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';

import { resendVerificationEmail } from '../api/auth.api';

export function useResendVerificationEmail() {
  return useMutation({
    mutationFn: () => resendVerificationEmail(),
    onSuccess: (response) => {
      toast.success(response.message);
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Could not send verification email. Please try again.');
    },
  });
}
